import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs'; 
import { AppConsts } from '@shared/app-consts';

@Injectable()
export class AddAuditDataInterceptorService implements HttpInterceptor { 
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
 
    let httpsReq = req;
    
    if(req.method == 'POST' && req.headers != null){
      httpsReq = req.clone({
        headers: req.headers.set("AUDIT-PROGRAM", AppConsts.AuditProgramme)
      });
    }
    
    return next.handle(httpsReq);
  } 
}
